import { render, staticRenderFns } from "./ServiceView.vue?vue&type=template&id=2130112f&"
import script from "./ServiceView.vue?vue&type=script&lang=js&"
export * from "./ServiceView.vue?vue&type=script&lang=js&"
import style0 from "./ServiceView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports